function UserReferralBlock({
  userId,
  isUserBlocked,
  setUserReferralBlockStatus,
  isLoadingReferralBlockStatus,
}) {
  return (
    <>
      <article className="question__container">
        <span className="question__title">Referrals Block</span>
        {isUserBlocked ? (
          <p>The user is blocked from referring friends.</p>
        ) : (
          <p>The user is allowed to refer friends.</p>
        )}
        <div className="question__buttons__container">
          <button
            className="btn question__button--block"
            onClick={() => setUserReferralBlockStatus(userId, true)}
            disabled={isUserBlocked || isLoadingReferralBlockStatus}
          >
            Block
          </button>
          <button
            className="btn btn-primary"
            onClick={() => setUserReferralBlockStatus(userId, false)}
            disabled={!isUserBlocked || isLoadingReferralBlockStatus}
          >
            Unblock
          </button>
        </div>
      </article>
      <div className="separatorLine" />
    </>
  );
}

export default UserReferralBlock;
